'use client';

import { useCallback, useEffect, useState } from 'react';

import type { RefObject } from 'react';

interface ContainerProps {
  bottom: number;
  height: number;
  left: number;
  right: number;
  top: number;
  width: number;
  x: number;
  y: number;
}

export const useBoundingClientRect = (
  containerRef: RefObject<HTMLDivElement>
): ContainerProps | null => {
  const [container, setContainer] = useState<ContainerProps | null>( null );

  const handleResize = useCallback( () => {
    if (containerRef.current) {
      const value = containerRef.current.getBoundingClientRect();

      setContainer( value );
    }
  }, [containerRef] );

  useEffect( () => {
    window.addEventListener( 'resize', handleResize );

    handleResize();

    return () => window.removeEventListener( 'resize', handleResize );
  }, [handleResize] );

  return container;
};
